import { RefObject, useEffect, useState } from 'react';

import useIntersectionObserver from '~hooks/useIntersectionObserver';

export function useDisplayTrigger(ref: RefObject<HTMLDivElement>) {
  const [isDisplayed, setIsDisplayed] = useState<boolean>();
  const entry = useIntersectionObserver(ref, {
    root: null,
    rootMargin: '0px',
    threshold: 0.5,
  });

  useEffect(() => {
    if (entry?.isIntersecting && !isDisplayed) {
      setIsDisplayed(true);
    }
  }, [entry, isDisplayed]);

  return isDisplayed || entry?.isIntersecting;
}
